import React from 'react';
import { STATUS_APPLICATION_SUPPLY } from 'helpers/constants';
import { Select } from 'components/ui/formik';
import Form from '../form';
import styles from '../../../order.module.scss';

const Management = ({ edit, values }) => {
  const isChangedStatus = edit.status !== Number(values.status);

  return (
    <>
      <div className={styles.item}>
        <Select label="Статус" name="status">
          {[
            STATUS_APPLICATION_SUPPLY.QUEUE,
            STATUS_APPLICATION_SUPPLY.CHECK,
            STATUS_APPLICATION_SUPPLY.COMPLETE,
            STATUS_APPLICATION_SUPPLY.CANCEL,
            STATUS_APPLICATION_SUPPLY.WAIT,
            STATUS_APPLICATION_SUPPLY.SHIPPED,
            STATUS_APPLICATION_SUPPLY.DELIVERED,
          ].map(value => (
            <option value={value} key={value}>
              {STATUS_APPLICATION_SUPPLY.toString(value)}
            </option>
          ))}
        </Select>
      </div>
      {isChangedStatus ? (
        <Form />
      ) : null}
    </>
  );
};

export default Management;
